const minutesRange = /^[0-5][0-9]?$|^59$/;
const monthDayRange = /([1-9]|[12][0-9]|3[01])$/;

const scheduleRegexes = { minutesRange, monthDayRange };

export default scheduleRegexes;
